import { IRolePermission } from "../IRequestModel/IRolePermission";

export function onCheckUserRolePermissionInLogic(
    userRoles: IRolePermission[],
    accessRoles: {
        id: number;
    }[]
) {
    Array.isArray(userRoles) && userRoles.forEach((userRole:any)  => {
        const role = Array.isArray(accessRoles) && accessRoles.some((accessRole) => {
            userRole.RoleId === Number(accessRole.id) || userRole.RoleId === Number(accessRole)
        })
        if (role) return role
    });
    return false;
}